var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDialer = function SvgDialer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79273 8.92824C11.0299 8.92824 12.0327 7.92536 12.0327 6.68824C12.0327 5.45112 11.0299 4.44824 9.79273 4.44824C8.55562 4.44824 7.55273 5.45112 7.55273 6.68824C7.55273 7.92536 8.55562 8.92824 9.79273 8.92824Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 8.92824C17.2379 8.92824 18.2407 7.92536 18.2407 6.68824C18.2407 5.45112 17.2379 4.44824 16.0007 4.44824C14.7636 4.44824 13.7607 5.45112 13.7607 6.68824C13.7607 7.92536 14.7636 8.92824 16.0007 8.92824Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2087 8.92824C23.4459 8.92824 24.4487 7.92536 24.4487 6.68824C24.4487 5.45112 23.4459 4.44824 22.2087 4.44824C20.9716 4.44824 19.9688 5.45112 19.9688 6.68824C19.9688 7.92536 20.9716 8.92824 22.2087 8.92824Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79273 15.1363C11.0299 15.1363 12.0327 14.1334 12.0327 12.8963C12.0327 11.6591 11.0299 10.6562 9.79273 10.6562C8.55562 10.6562 7.55273 11.6591 7.55273 12.8963C7.55273 14.1334 8.55562 15.1363 9.79273 15.1363Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 15.1363C17.2379 15.1363 18.2407 14.1334 18.2407 12.8963C18.2407 11.6591 17.2379 10.6562 16.0007 10.6562C14.7636 10.6562 13.7607 11.6591 13.7607 12.8963C13.7607 14.1334 14.7636 15.1363 16.0007 15.1363Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2087 15.1363C23.4459 15.1363 24.4487 14.1334 24.4487 12.8963C24.4487 11.6591 23.4459 10.6562 22.2087 10.6562C20.9716 10.6562 19.9688 11.6591 19.9688 12.8963C19.9688 14.1334 20.9716 15.1363 22.2087 15.1363Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79273 21.3443C11.0299 21.3443 12.0327 20.3414 12.0327 19.1043C12.0327 17.8671 11.0299 16.8643 9.79273 16.8643C8.55562 16.8643 7.55273 17.8671 7.55273 19.1043C7.55273 20.3414 8.55562 21.3443 9.79273 21.3443Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 21.3443C17.2379 21.3443 18.2407 20.3414 18.2407 19.1043C18.2407 17.8671 17.2379 16.8643 16.0007 16.8643C14.7636 16.8643 13.7607 17.8671 13.7607 19.1043C13.7607 20.3414 14.7636 21.3443 16.0007 21.3443Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2087 21.3443C23.4459 21.3443 24.4487 20.3414 24.4487 19.1043C24.4487 17.8671 23.4459 16.8643 22.2087 16.8643C20.9716 16.8643 19.9688 17.8671 19.9688 19.1043C19.9688 20.3414 20.9716 21.3443 22.2087 21.3443Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 27.5523C17.2379 27.5523 18.2407 26.5494 18.2407 25.3123C18.2407 24.0751 17.2379 23.0723 16.0007 23.0723C14.7636 23.0723 13.7607 24.0751 13.7607 25.3123C13.7607 26.5494 14.7636 27.5523 16.0007 27.5523Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDialer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dialer.cf91e4d9.svg";
export { ForwardRef as ReactComponent };